import { render, staticRenderFns } from "./TusButton.vue?vue&type=template&id=d4e35a28&"
import script from "./TusButton.vue?vue&type=script&lang=ts&"
export * from "./TusButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports